export const isUndefined = (value: unknown): value is undefined =>
  typeof value === "undefined";
export const isNull = (value: unknown): value is null => value === null;
export const isNumber = (value: unknown): value is number =>
  typeof value === "number";
export const isString = (value: unknown): value is string =>
  typeof value === "string";
export const isObject = (value: unknown): value is object =>
  typeof value === "object";
export function isArray<T>(value: unknown): value is Array<T> {
  return Object.prototype.toString.call(value) === "[object Array]";
}
